<template>
  <div>
    <b-modal
      id="osko-profile-modal"
      title="Edit Osko Profile"
      hide-footer
      centered
      size="md"
    >
      <div class="text-black">
        <h5 class="font-weight-bold">Osko Payments</h5>
        <b-button-group class="w-100">
          <b-button
            :variant="oskoEnabled ? 'primary' : 'light'"
            @click="oskoEnabled = true"
          >
            <feather-icon icon="CheckIcon" /> Enable
          </b-button>

          <b-button
            :variant="!oskoEnabled ? 'danger' : 'light'"
            @click="oskoEnabled = false"
          >
            <feather-icon icon="XIcon" /> Disable
          </b-button>
        </b-button-group>

        <div class="text-center mt-1">
          Current status:
          <span :class="oskoEnabled ? 'text-success' : 'text-danger'">{{
            oskoEnabled ? "Enabled" : "Disabled"
          }}</span>
        </div>
        <div class="font-weight-bold">Osko Delay</div>
        <b-row>
          <b-col cols="12" class="mt-1">
            <b-input-group label="Set Delay:">
              <b-form-input
                v-model="delayValue"
                type="number"
                min="0"
              ></b-form-input>
              <b-input-group-append>
                <b-form-select
                  v-model="delayUnit"
                  style="border-radius: 0 4px 4px 0"
                >
                  <option>Minutes</option>
                  <option>Hours</option>
                </b-form-select>
              </b-input-group-append>
            </b-input-group>
          </b-col>
        </b-row>

        <div class="text-center text-muted mt-1">
          Set the delay before Osko payments are processed.
        </div>

        <!-- FOOTER -->
        <hr class="my-1" />

        <div class="d-flex justify-content-end">
          <b-button variant="light" @click="hideModal" class="mr-1">
            Cancel
          </b-button>

          <b-button variant="dark" @click="save">
            <feather-icon icon="SaveIcon" />
            Save Changes
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BModal,
  BButton,
  BButtonGroup,
  BFormInput,
  BFormSelect,
  BRow,
  BCol,
  BFormGroup,
  BInputGroupAppend,
  BInputGroup,
} from "bootstrap-vue";
export default {
  components: {
    BModal,
    BButton,
    BButtonGroup,
    BFormInput,
    BFormSelect,
    BFormGroup,
    BRow,
    BInputGroupAppend,
    BCol,
    BInputGroup,
  },
  data() {
    return {
      oskoEnabled: true,
      delayValue: 4,
      delayUnit: "Minutes",
    };
  },
  methods: {
    save() {
      this.hideModal();
    },
    hideModal() {
      this.$$bvModal.hide("osko-profile-modal");
    },
  },
};
</script>

<style>
.osko-modal .modal-content {
  border-radius: 16px !important;
  padding: 24px;
}

.close-button {
  border: none;
  background: none;
}

.osko-toggle .btn {
  border-radius: 8px !important;
  font-weight: 600;
}
</style>
